<template>
    <div class="userInfo">
        <router-view></router-view>

        <div class="infoHolder">
            <i id="closeInfo" class="material-icons" @click="closeInfo">close</i>
            <form class="userInfoForm" autocomplete="off">
                <input id="inputUnum" class="userInfoInput" type="text" placeholder="U number" :value="userInfo.unum">
                <input id="inputFname" class="userInfoInput" type="text" placeholder="first name"
                       :value="userInfo.fname">
                <input id="inputLname" class="userInfoInput" type="text" placeholder="last name"
                       :value="userInfo.lname">

                <input id="inputAutlev" class="userInfoInput" type="text" placeholder="autlev" :value="userInfo.autlev">
                stao:
                <select id="inputStao" v-model="userInfo.stao">
                    <option v-for="option in staos"
                            :key="option.id"
                            :value="option.id"
                            class="userInfoInput"
                    >
                        {{option.name}}
                    </option>
                </select>
                lagerCheff:
                <select id="inputLagerCheff" v-model="userInfo.lagerCheff">
                    <option value="0">
                        -
                    </option>
                    <option v-for="option in staos"
                            :key="option.id"
                            :value="option.id"
                            class="userInfoInput"
                    >
                        {{option.name}}
                    </option>
                </select>
                <button class="train-select__delete" @click.prevent="changePW">change PW</button>

                <div class="search-form__button">
                    <button class="saveButton" @click.prevent="save">save</button>
                    <button class="train-select__delete" @click.prevent="del">del</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            newUserInfo: {
                unum: '',
                fname: '',
                lname: '',
                stao: '',
                autlev: '',
                lagerCheff: 0
            }
        }
    },
    computed: {
        userInfo() {
            return this.$store.getters['user/userInfo'];
        },
        staos() {
            return this.$store.getters['user/staos'];
        }
    },
    methods: {
        closeInfo() {
            this.$router.go(-1);
        },
        save() {
            this.newUserInfo.unum = document.getElementById('inputUnum').value;
            this.newUserInfo.fname = document.getElementById('inputFname').value;
            this.newUserInfo.lname = document.getElementById('inputLname').value;
            this.newUserInfo.email = this.userInfo.email;
            this.newUserInfo.stao = document.getElementById('inputStao').value;
            this.newUserInfo.autlev = document.getElementById('inputAutlev').value;
            this.newUserInfo.lagerCheff = document.getElementById('inputLagerCheff').value;
            // this.newUserInfo.pw = document.getElementById("inputPw").value;
            // this.newUserInfo.rpw = document.getElementById("inputRpw").value;

            this.$store.dispatch('user/saveNewUserData', { new: this.newUserInfo, old: this.userInfo });
        },
        del() {
            this.$store.dispatch('user/userToDel', this.userInfo.id);
            this.$router.push({ name: 'delfuserverify' });
        },
        changePW() {
            const data = { id: this.userInfo.id };
            this.$store.dispatch('user/changePW', data);
        }
    },
    mounted() {
        document.getElementById('inputAutlev').title = '1: settings\n2: FDB\n3: edit FDB\n4: del from FDB\n6: Lager Chef\n7: Lagereinfüllen\n8: SRM\n9: SFS\nA: EM';
        this.$store.dispatch('user/getStaos');
    }
}
</script>

<style scoped lang="scss">
    #closeInfo {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        font-size: 2.5rem;
    }

    .search-form__button {
        display: flex;
        flex-direction: row;
    }

    .userInfo {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        /*background-color: blue;*/
    }

    .infoHolder {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        /*height: 12.5rem;*/
        background-color: $color-white;
        @include default-shadow;
        padding-top: 0.625rem;
        padding-bottom: 0.625rem;
    }

    .userInfoForm {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 1.25rem;
        margin-right: 2.5rem;
    }

    .userInfoInput {
        font-size: 1.25rem;

    }

    #inputStao {
        height: 3rem;
        font-size: 1.5rem;
    }

    #inputLagerCheff {
        height: 3rem;
        font-size: 1.5rem;
    }

    .saveButton {
        flex: 4;
        width: 100%;
        color: $color-white;
        font-size: 1.25rem;
        background-color: $color-green;
    }

    .train-select__delete {
        flex: 1;
        width: 100%;
        color: $color-white;
        font-size: 1.25rem;
        background-color: $color-red;
        min-height: 2.5rem;
    }

    @include medium {
        .infoHolder {
            width: 31rem;
        }

    }

    @include extra-large {
        .infoHolder {
            width: 600px;
        }

        .userInfoInput {
            font-size: 2rem;
        }

        .saveButton {
            font-size: 2.5rem;
        }

        .train-select__delete {
            font-size: 2rem;
        }

    }

</style>
